import { useLocation } from "react-router-dom";

// Where the department screens link to.
//
// DepartmentsList and OrgChart are mounted in two places now:
//
//   /ats/departments, /ats/org        inside the ATS module, its own shell
//   /create-department                inside the Daily Tick shell, reached from
//                                     that sidebar's Departments and Org Chart
//                                     entries
//
// Same components in both, so they cannot hard-code their own URLs: a link back
// to /ats from the Daily Tick copy would drop the user out of the shell they were
// working in, losing that sidebar and its store switcher, which reads as the app
// jumping somewhere on its own.
//
// Derived from the current path rather than passed as a prop because these
// components are several layers deep and every intermediate one would otherwise
// have to thread it through, with the one that forgot silently teleporting.

export const ATS_DEPT_ROUTES = {
  // The card grid.
  list: "/ats/departments",
  // The whole org chart, every department as its own tree.
  chart: "/ats/org",
  // One department's chart.
  detail: (id) => `/ats/departments/${id}`,
  // Where the back arrow goes when nothing told it where the user came from —
  // a refresh, or a pasted link. Both hosts point it at whichever of their two
  // screens is the more natural landing place.
  back: "/ats/org",
};

export const HOST_DEPT_ROUTES = {
  // The Daily Tick departments screen has two tabs and the org list is the
  // second, so the tab has to be named or "back" lands on the ticket one.
  list: "/create-department?tab=organization",
  chart: "/create-department/org",
  detail: (id) => `/create-department/org/${id}`,
  // The list rather than the chart: this shell's Departments entry is where
  // people arrive from, so an unattributed "back" belongs there.
  back: "/create-department?tab=organization",
};

export const useDeptRoutes = () => {
  const { pathname } = useLocation();
  return pathname.startsWith("/ats") ? ATS_DEPT_ROUTES : HOST_DEPT_ROUTES;
};
